import { useNavigate } from 'react-router-dom';
import editSvg from 'assets/icons/edit.svg';
import copySvg from 'assets/icons/copy.svg';
import { DirectSalesFilteredCampaignsTableResponse } from 'components/common/types/DirectSalesCampaign.types';
import IconButton from 'lib/IconButton';
import { ButtonSize } from 'lib/IconButton/IconButton.types';
import { useToggle } from 'customHooks/useToggle';
import { useHasDealReadOnlyPermission } from 'customHooks/useHasDealReadOnlyPermission';
import CampaignDuplicateModal from 'components/common/CampaignDuplicationModal/CampaignDuplicationModal';

type ActionRendererProps = {
  data?: DirectSalesFilteredCampaignsTableResponse;
};

const ActionRenderer: React.FC<ActionRendererProps> = ({ data = {} }) => {
  const navigate = useNavigate();
  const hasDealReadOnlyPermission = useHasDealReadOnlyPermission();
  const {
    isOpen: isCampaignDuplicationModalOpen,
    open: openCampaignDuplicationModal,
    close: closeCampaignDuplicationModal,
  } = useToggle();

  const { reference, dealLineStates } = data;

  if (!reference) return null;

  const onEditButtonClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
    e.preventDefault();
    navigate(`/planner/direct-sales/${reference}`);
  };

  const onCopyButtonClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
    e.preventDefault();
    openCampaignDuplicationModal();
  };

  return (
    <span className="table-action-button flex">
      <IconButton
        icon={editSvg}
        name="Edit campaign"
        dataTestId={`edit-${reference}`}
        handleOnClick={onEditButtonClick}
        buttonSize={ButtonSize.LARGE}
      />
      {!hasDealReadOnlyPermission && (
        <IconButton
          icon={copySvg}
          name="Duplicate campaign"
          dataTestId={`duplicate-${reference}`}
          handleOnClick={onCopyButtonClick}
          buttonSize={ButtonSize.LARGE}
          isDisabled={hasDealReadOnlyPermission}
        />
      )}
      <CampaignDuplicateModal
        isOpen={isCampaignDuplicationModalOpen}
        onClose={closeCampaignDuplicationModal}
        dealLineStates={dealLineStates ?? []}
        campaignId={reference}
      />
    </span>
  );
};

export default ActionRenderer;
